import React from 'react'
import { Link } from 'react-router-dom'
import { count } from '../staff-leads/model'
import { flowRows } from './model'

// Where the range's leads went, each bar a share of received. Intake
// rejections never became leads, so they are not a bar: one line under the
// bars, linking to the rejection screen.
export default function LeadFlowCard({ flow }) {
  const rows = flowRows(flow)
  const blocked = Number(flow?.blocked_at_intake || 0)
  return (
    <section className="card" aria-labelledby="hm-flow-title" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <h2 id="hm-flow-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Lead flow</h2>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {rows.map((r) => (
          <li key={r.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 12, marginBottom: 4 }}>
              <span style={{ color: 'var(--text-secondary)' }}>{r.label}</span>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--text-primary)' }}>
                <strong>{count(r.value)}</strong>
                {r.id !== 'received' && <span style={{ color: 'var(--text-muted)' }}> · {r.pct.toLocaleString('en-US', { maximumFractionDigits: 1 })}%</span>}
              </span>
            </div>
            <div aria-hidden="true" style={{ height: 8, borderRadius: 999, background: 'var(--bg-raised)', overflow: 'hidden' }}>
              <div style={{ width: `${Math.min(100, r.pct)}%`, height: '100%', background: r.color, borderRadius: 999 }} />
            </div>
          </li>
        ))}
      </ul>
      {blocked > 0 && (
        <p style={{ margin: 0, fontSize: 12, color: 'var(--text-muted)' }}>
          {count(blocked)} more never became leads (blocked at intake) · <Link className="hm-link" to="/rejected-submissions">View</Link>
        </p>
      )}
    </section>
  )
}
